var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import tinycolor from "tinycolor2";
import { IconButton } from "@irati/ui/src/Button";
import IconWrapper from "./IconWrapper";
import { ColorCss } from "./styled";
var CustomColorPreview = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  padding: 8px;\n  border: ", " ;\n  background-color: ", ";\n  color: ", ";\n  ", "\n"], ["\n  ", "\n  padding: 8px;\n  border: ", " ;\n  background-color: ", ";\n  color: ", ";\n  ", "\n"])), ColorCss, function (_a) {
    var isValidHex = _a.isValidHex, color = _a.color;
    return ((isValidHex && color) ? "none" : "2px dashed #909090");
}, function (_a) {
    var isValidHex = _a.isValidHex, color = _a.color;
    return ((isValidHex && color) ? color : "white");
}, function (_a) {
    var isValidHex = _a.isValidHex, color = _a.color;
    return ((isValidHex && color) && !tinycolor(color).isLight() ? "white" : "black");
}, function (_a) {
    var isAnySelected = _a.isAnySelected, selected = _a.selected;
    return ((isAnySelected && !selected) && "opacity: 0.5;");
});
var CustomColorPreviewItem = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement(CustomColorPreview, __assign({ small: true }, props)),
    React.createElement(IconWrapper, { onClick: props.onClick, hide: !props.selected || !props.isValidHex },
        React.createElement(IconButton, { inline: true, icon: "tick", onClick: function () { }, color: tinycolor(props.color).isLight() ? "black" : "white" })))); };
export default CustomColorPreviewItem;
var templateObject_1;
